// import {useCallback, useState} from "react";
// import useStore from "./useStore";
//
// interface UseApiReturn<T> {
//     loading: boolean;
//     error: any;
//     remove: (url: string) => Promise<void>;
// }
//
// const useDelete = <T = any>(): UseApiReturn<T> => {
//     const {accessToken} = useStore()
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState<any>(null);
//
//
//     const request = useCallback(
//         async (url: string, options: RequestInit) => {
//             setLoading(true);
//             setError(null);
//
//             try {
//                 const res = await fetch(url, options);
//                 const result = await res.json();
//
//                 if (!res.ok) {
//                     throw result;
//                 }
//                 return result;
//             } catch (err) {
//                 setError(err);
//                 throw err;
//             } finally {
//                 setLoading(false);
//             }
//         },
//         []
//     );
//
//     const remove = async (url: string) => {
//         return request(url, {
//             method: "DELETE",
//             headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
//         });
//     };
//
//     return { loading, error, remove };
// };
//
// export default useDelete;

import {useCallback, useState} from "react";
import useStore from "./useStore";

interface UseApiReturn {
    loading: boolean;
    error: any;
    remove: (url: string) => Promise<void>;
}

const useDelete =(): UseApiReturn => {
    const {accessToken} = useStore()
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(null);


    const request = useCallback(
        async (url: string, options: RequestInit) => {
            setLoading(true);
            setError(null);

            try {
                const res = await fetch(url, options);
                const result = await res.json();

                if (!res.ok) {
                    throw result;
                }
                return result;
            } catch (err) {
                setError(err);
                return {
                    success: false,
                    error: err,
                };
            } finally {
                setLoading(false);
            }
        },
        []
    );

    const remove = async (url: string) => {
        return request(url, {
            method: "DELETE",
            headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
        });
    };

    return { loading, error, remove };
};

export default useDelete;
